import { NAVIGATION_EVENTS } from "@/lib/events/constants";
import { emitEvent } from "@/lib/events/helpers";
import { useGlobalErrorDialog } from "./state";
import type { GlobalErrorDialogProps } from "./types";

/**
 * グローバルエラーダイアログを表示する
 */
export function openGlobalErrorDialog(props: GlobalErrorDialogProps) {
  useGlobalErrorDialog.getState().open(props);
}

/**
 * グローバルエラーダイアログを閉じる
 */
export function closeGlobalErrorDialog() {
  useGlobalErrorDialog.getState().close();
}

/**
 * - 履歴が存在する場合はブラウザバックする
 * - 履歴が存在しない場合（直リンクなど）はアプリ一覧(/)に遷移する
 */
export function historyBackIfPossible() {
  // NOTE: routerの機能をイベント経由で呼び出し
  emitEvent(NAVIGATION_EVENTS.HISTORY_BACK, {
    fallbackUrl: "/",
  });
}
